import React, { useContext, useRef } from "react";
import { Paper, Button, Typography, TableContainer, TableHead } from "@mui/material";
import { AppContext } from "../../App";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { useReactToPrint } from 'react-to-print'


export default function InvoiceReview(){

  const { artistInfo, eventDetails } = useContext(AppContext)

  const printComponentRef = useRef()
  const handlePrint = useReactToPrint({
    content: () => printComponentRef.current,
  })

  function createData(details, price) {
    return { details, price };
  }
  
  const rows = [
    createData(`Performance Fee - ${eventDetails.eventDetails.eventName} - ${eventDetails.eventDetails.eventDate}`, eventDetails.eventDetails.performFee),
    createData('Additional Fee', eventDetails.eventDetails.addFee)
  ];

  return (
    <div className="event details">
      <h3 className="section-title">
            Invoice Review
      </h3>
      <Paper elevation={3} ref={printComponentRef}>
        <Typography sx={{padding: '1em 0 1em 0'}} variant="h5">
          Invoice
        </Typography>
        <img className="invoice-icon" src={require("../../invoice.png")} />
        <div className="invoice-infobox from">
          From: {artistInfo.bandName} <br/>
          Email: {artistInfo.adminDetails.email} <br/>
          Phone: {artistInfo.adminDetails.phone} <br/>
          Rep.: {artistInfo.adminDetails.firstName} {artistInfo.adminDetails.lastName}
        </div>
        <div className="invoice-infobox to">
          To: {eventDetails.promoterDetails.promoterName} <br/>
          Address: {eventDetails.promoterDetails.promoterAddress} <br/>
          Company Reg. No.: {eventDetails.promoterDetails.companyReg} <br/>
          VAT No.: {eventDetails.promoterDetails.vatNo} <br/>
          Contact Person: {eventDetails.promoterDetails.companyContactPerson} <br/>
          Contact Number: {eventDetails.promoterDetails.companyContactNumber} <br/>
          Email: {eventDetails.promoterDetails.promoterEmail} <br/>
        </div>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={{fontWeight: '700'}}>Details</TableCell>
                <TableCell sx={{fontWeight: '700'}}>Price</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.map((row) => (
                <TableRow 
                  key={row.details}>
                    <TableCell>
                      {row.details}
                    </TableCell>
                    <TableCell>
                      {row.price}
                    </TableCell>

                </TableRow>
                ))}
                <TableRow>
                  <TableCell sx={{fontWeight: '700'}}>TOTAL</TableCell>
                  <TableCell sx={{fontWeight: '700', fontSize: '1.35em'}}>{Number(eventDetails.eventDetails.performFee) + Number(eventDetails.eventDetails.addFee)}</TableCell>
                </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <div className="payment-block">
          <p className="invoice-section-heading">Terms of Payment</p>
          <p>{eventDetails.eventDetails.payTerms}</p>
        </div>
        <div className="payment-block">
          <p className="invoice-section-heading">Bank Details</p>
          <p>Account Holder: {artistInfo.adminDetails.bankAccHolder}<br/>
          Bank Name: {artistInfo.adminDetails.bankName} <br/>
          Account Number: {artistInfo.adminDetails.accNumber} <br/>
          Branch Code: {artistInfo.adminDetails.branchCode}
          </p>
        </div>
      </Paper>
      <Button onClick={handlePrint}>Print</Button>
    </div>
  )

}